var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.532 2.532c.11-.11.258-.17.412-.17h5.688a.583.583 0 0 1 .583.582v.632a.68.68 0 0 0 1.361 0v-.632A1.944 1.944 0 0 0 8.632 1H2.944A1.944 1.944 0 0 0 1 2.944v5.688a1.945 1.945 0 0 0 1.944 1.944h.632a.68.68 0 0 0 0-1.36h-.632a.583.583 0 0 1-.583-.584V2.944c0-.154.062-.303.171-.412Zm4.253 4.836c0-.322.26-.583.583-.583h5.688c.322 0 .583.26.583.583v5.688a.583.583 0 0 1-.583.583H7.368a.583.583 0 0 1-.583-.583V7.368Zm.583-1.944c-1.074 0-1.944.87-1.944 1.944v5.688c0 1.073.87 1.944 1.944 1.944h5.688C14.129 15 15 14.13 15 13.056V7.368c0-1.074-.87-1.944-1.944-1.944H7.368Z",
    fill: "currentColor"
  })));
};

export default SvgCopyIcon;